/*** IMPORTS FROM imports-loader ***/
var define = false;

import loadImage from './loadImage.js';
import preloadImages from './preloadImages.js';
export default {
  loadImage,
  preloadImages
};
